module.exports = __webpack_public_path__ + "static/media/tariffs_yellow-01.870a1d44.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Icons/tariffs_yellow-01.png
// module id = 7701
// module chunks = 0